<template>
  <!-- <div id="accordion">
    <div class="card">
      <div class="card-header" id="headingOne">
        <h5 class="mb-0">
          <button
            class="btn btn-link"
            data-toggle="collapse"
            data-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            Worklog opcije
          </button>
        </h5>
      </div>

      <div
        id="collapseOne"
        class="collapse show"
        aria-labelledby="headingOne"
        data-parent="#accordion"
      >
        <div class="card-body">
          <WorklogOptions />
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header" id="headingTwo">
        <h5 class="mb-0">
          <button
            class="btn btn-link collapsed"
            data-toggle="collapse"
            data-target="#collapseTwo"
            aria-expanded="false"
            aria-controls="collapseTwo"
          >
            Customers opcije
          </button>
        </h5>
      </div>
      <div
        id="collapseTwo"
        class="collapse"
        aria-labelledby="headingTwo"
        data-parent="#accordion"
      >
        <div class="card-body">
          <CustomerUsers />
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header" id="headingThree">
        <h5 class="mb-0">
          <button
            class="btn btn-link collapsed"
            data-toggle="collapse"
            data-target="#collapseThree"
            aria-expanded="false"
            aria-controls="collapseThree"
          >
            Administratorske opcije
          </button>
        </h5>
      </div>
      <div
        id="collapseThree"
        class="collapse"
        aria-labelledby="headingThree"
        data-parent="#accordion"
      >
        <div class="card-body">
          <AdminOptions />
        </div>
      </div>
    </div>
  </div> -->
  <div class="container">
    <div class="card">
      <div class="card-header">
        Radni nalozi podesavanja
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <router-link :to="'units-options'">
              <h6 class="card-title">Jedinica mjere</h6>
            </router-link>
            <router-link :to="'work-time-options'">
              <h6 class="card-title">Radno vrijeme</h6>
            </router-link>
            <router-link :to="'known-problems-options'">
              <h6 class="card-title">Prijava problema</h6>
            </router-link>
          </div>
          <div class="col-md-4">
            <router-link :to="'location-options'">
              <h6 class="card-title">Lokacije</h6>
            </router-link>
            <router-link :to="'city-options'">
              <h6 class="card-title">Gradovi</h6>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-3">
      <div class="card-header">
        Klijentska podesavanja
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <router-link :to="'add-customer-user'">
              <h6 class="card-title">Klijentski korisnici</h6>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-3">
      <div class="card-header">
        Administratorska podesavanja
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <router-link to="/add-admin">
              <h6 class="card-title">Administratori</h6>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import CustomerUsers from "@/components/Customers/CustomerUsers";
import AdminOptions from "@/components/AdminOptions/AdminOption";
import WorklogOptions from "@/components/Worklog/WorklogOptions";
export default {
  components: {
    CustomerUsers,
    AdminOptions,
    WorklogOptions
  },
  created() {
    this.$store.dispatch("getOptions");
  },
  data() {
    return {};
  },
  methods: {
    goToLocation(e) {
      e.preventDefault();
      this.$router.push();
    }
  }
};
</script>
